export const PROJECTS_OVERVIEW_LIMIT = 6;
